import * as React from 'react'
import { OnboardingComponentProps } from '.'
import Tag from '@doordash/component-tag'
import { TagProps } from '@doordash/component-tag/src/types/TagTypes'

export const TagComponent: React.FC<OnboardingComponentProps &
  TagProps> = React.memo(props => <Tag {...props} />)
